import React from 'react';
import Banner from '../Banner/Banner';
import ByingConfidence from '../ByingConfidence/ByingConfidence';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <ByingConfidence></ByingConfidence>
        </div>
    );
};

export default Home;